import * as THREE from 'three'
import { Text } from 'troika-three-text'

import BaseObject from './baseObject'
import GlassDesignerTypes from '../types'


// Label Object
// Displays a text label within the rectangle
export default class LabelObject extends BaseObject {
  constructor(editor, options = {}) {
    super(editor)

    this.persistable = false
    this.position = new THREE.Vector2(0, 0)
    this.scale = new THREE.Vector2(1, 1)
    this.colour = options.colour || '#000000'
    this.opacity = parseFloat(options.opacity || 1.0)
    this.text = options.text || ''
    this.fontSize = parseInt(options.fontSize || 12)
    this.anchorX = options.anchorX || 'center'
    this.anchorY = options.anchorY || 'middle'

    this.textObj = null
    this.objectGeometry = null

    this.sceneObject = new THREE.Object3D()
    this.updateSceneObject()
  }

  /**
   * Dispose the object
   */
  dispose() {
    super.dispose()

    if(this.objectGeometry) {
      this.objectGeometry.dispose()
      this.objectGeometry = null
    }
    if(this.textObj) {
      this.textObj.dispose()
      this.textObj = null
    }
  }

  // onBeforeRender
  // Called prior to rendering of the object
  onBeforeRender() {
    super.onBeforeRender()

    if(this.textObj) {
      this.textObj.scale.set(this.scale.x, -this.scale.y, 1.0)    // Minus to flip text to match our coords
    }    
  }


  // Update the position of the label
  setPosition(pos) {
    this.position.set(pos.x, pos.y)

    if(this.textObj) {
      this.textObj.position.set(this.position.x, this.position.y, 210)
      this.textObj.sync()
    }
  }


  /**
   * Update the label text
   */
  setText(text) {
    this.text = text
    if(this.textObj) {
      this.textObj.text = this.text
      this.textObj.sync()
    }
  }


  /**
   * Set the X Anchor property
   */
  setAnchorX(anchor) {
    this.anchorX = anchor
    if(this.textObj) {
      this.textObj.anchorX = this.anchorX
      this.textObj.sync()
    }
  }


  /**
   * Set the Y Anchor property
   */
   setAnchorY(anchor) {
    this.anchorY = anchor
    if(this.textObj) {
      this.textObj.anchorY = this.anchorY
      this.textObj.sync()
    }
  }


  /**
   * Build the scene object
   */
  updateSceneObject() {
    if(this.objectGeometry) {
      this.objectGeometry.dispose()
      this.objectGeometry = null
    }
    if(this.textObj) {
      this.textObj.dispose()
      this.textObj = null
    }

    this.clearSceneObject()

    this.textObj = new Text()
    this.textObj.text = this.text
    this.textObj.position.set(this.position.x, this.position.y, 210)
    this.textObj.color = this.colour
    this.textObj.fontSize = this.fontSize
    this.textObj.anchorX = this.anchorX
    this.textObj.anchorY = this.anchorY

    // Flip to match our coordinate system
    this.textObj.scale.y = -1

    this.textObj.material.opacity = this.opacity
    this.sceneObject.add(this.textObj)

    this.textObj.addEventListener('synccomplete', () => {
      this.editor.flagRenderRequired()
    })

    this.textObj.sync()
  }



}
